/**
 * Container template for a component.
 */

/* Import the component from the component path */
import Component from '../components/BlindForm'

import { connect } from 'react-redux'
import { Dispatch, Action } from 'redux'

/* Import RootStoreState */
import { RootStoreState } from 'modules/root'
// import { saveCurtain } from '../actions'

/* Import module actions */
import * as a from '../../actions'
import * as dtp from 'modules/database/types/blinds'
import * as dt from 'modules/database/types'
import * as s from '../../selectors'
import * as ps from 'modules/project/selectors'

/**
 * Interface for properties that the container passes to the component.
 */
export interface Props {
	project: dt.ProjectWithProducts
	productId: dt.ProductID
	formValue: dtp.Blind
	currentForm?: string
}

export interface OwnProps {
	
}

/**
 * Interface for action callbacks that the container exposes to the component.
 * The component's `this.props` is typed `Props & Actions`.
 */
export interface Actions {
	onChangeFormValue: (newFormValue: dtp.Blind | undefined) => void
	onChooseProductForm: (form: string) => void
	onNewProduct: (projectId: dt.ProjectID, productType: dt.ProductType) => void
}

/** Populate the Props from the store state. */
const mapStateToProps = (state: RootStoreState): Props => {
	const project = ps.currentProject(state)!

	return {
		project,
		productId: state.product.currentProduct!.productId,
		formValue: s.currentProductFormValue(state),
		currentForm: state.product.currentForm,
	}
}

/** Populate the Actions with the callbacks for the component. */
const mapDispatchToProps = (dispatch: Dispatch<Action>): Actions => ({
	onChangeFormValue: (newFormValue: dtp.Blind | undefined) => {
		if (newFormValue) {
			dispatch(a.updateCurrentProductDetails(newFormValue))
		}
	},
	onChooseProductForm: (form) => {
		dispatch(a.chooseProductForm(form))
	},
	onNewProduct: (projectId, productType) => {
		dispatch(a.newProduct({
			projectId,
			productType,
			navigationReplace: true,
		}))
	},
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
